module.exports = __webpack_public_path__ + "img/97dfedf.png";